import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

export interface Props {
  investmentType: 'keep' | 'earn' | 'grow';
  className?: string;
}

export const KeepEarnGrowFadeImagesStatic: React.FC<Props> = ({
  investmentType,
  className,
}) => {
  if (investmentType === 'keep') {
    return (
      <>
        <div className="visibleSmOrGreater">
          <StaticImage
            className={className}
            src="../../assets/images/mountains-keep.png"
            alt=""
            placeholder="blurred"
          />
        </div>
        <div className="visibleXsOnly">
          <StaticImage
            className={className}
            src="../../assets/images/mountains-keep-mobile.png"
            alt=""
            placeholder="blurred"
          />
        </div>
      </>
    );
  }

  if (investmentType === 'earn') {
    return (
      <>
        <div className="visibleSmOrGreater">
          <StaticImage
            className={className}
            src="../../assets/images/ascent-hero.jpg"
            alt=""
            placeholder="blurred"
          />
        </div>
        <div className="visibleXsOnly">
          <StaticImage
            className={className}
            src="../../assets/images/ascent-hero-mobile.png"
            alt=""
            placeholder="blurred"
          />
        </div>
      </>
    );
  }
  if (investmentType === 'grow') {
    return (
      <>
        <div className="visibleSmOrGreater">
          <StaticImage
            className={className}
            src="../../assets/images/mountains-grow.png"
            alt=""
            placeholder="blurred"
          />
        </div>
        <div className="visibleXsOnly">
          <StaticImage
            className={className}
            src="../../assets/images/mountains-grow-mobile.png"
            alt=""
            placeholder="blurred"
          />
        </div>
      </>
    );
  }

  return null;
};
